import React, {useState} from "react"
import {Tab, Stack, Grid} from "@mui/material";
import {checkQueryKey, formatTime, getSellerNames} from "@/helper/method";
import Box from "@mui/material/Box";
import {GridItem} from "@/widget/GridItem/GridItem";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {GridColDef,} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {PatentVO, useQueryPatent, useQueryPatentPage} from "@/service/patent.s";
import {PatentPO} from "@/model/product";
import Chip from "@mui/material/Chip";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {useDrawerModal} from "@/store/global.c";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import {TaskTable} from "@/widget/CommonDetail/TaskTable";
import {useAllDict} from "@/store/dict.c";
import {FileTable} from "@/widget/CommonDetail/FileTable";
import {roleAlias, writeStatus} from "@/helper/constant";
import {MonitorTable} from "@/widget/CommonDetail/MonitorTable";
import {useAuthInfo} from "@/store/account.c";
import {ContactDetail} from "@/widget/CommonDetail/PaybackDetail";

export const ViewPatent = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: patentData, isLoading: patentLoading} = useQueryPatent({id: drawerId!})
    const [tab, setTab] = useState<number>(1)
    const {patentStatus, fileCode} = useAllDict()
    const {
        mutate: patentPageMutate,
        data: patentPageData,
        isPending: patentPagePending,
    } = useQueryPatentPage(0)
    const {role: {roleAlias: roleName}} = useAuthInfo()
    const patent = patentData?.data || {} as PatentVO

    const patentColumns: GridColDef<PatentPO>[] = [
        {
            field: "patentName", headerName: "专利名称", flex: 0.5, renderCell: ({row}) => {
                return <Stack alignContent={'center'} alignItems={'center'} direction={'row'} spacing={0.5}>
                    {drawerId == row?.id && <Chip size={'small'} variant={'outlined'} color={'primary'} label={"当前"}/>}
                    <Box component={'span'}>
                        {isEmpty(row.patentName) ? '待定' : row.patentName}
                    </Box>
                </Stack>
            }
        },
        {
            field: "patentNo",
            headerName: "专利号/申请号",
            flex: 0.4,
            valueFormatter: value => value || '-'
        },
        {
            field: "price",
            headerName: "价格",
            flex: 0.2
        },
        {
            field: "writer",
            headerName: "撰稿人",
            flex: 0.2
        },
        {
            field: "writeStatus",
            headerAlign: 'center',
            align: "center",
            headerName: "撰写状态",
        },
    ];

    return <>
        <ResultWrapper isLoading={patentLoading} isEmpty={isEmpty(patent)}>
            <Stack width={'inherit'} direction={'column'} gap={2}>
                <Grid
                    spacing={3}
                    container>
                    <GridItem title={'内部编号'} content={patent?.id}/>
                    <GridItem title={'服务类型'} content={patent?.kind || "-"}/>
                    <GridItem title={'专利名称'} content={patent?.patentName || "待定"}/>
                    <GridItem title={'申请号/专利号'}
                              content={patent?.applyNo}/>
                    <GridItem title={'申请类型'} content={patent?.category}/>
                    <GridItem title={'申请日'} content={formatTime("D", patent?.applyDate)}/>
                    <GridItem title={'案件状态'} content={patent?.patentStatus}/>
                    <GridItem title={'公告号'} content={patent?.bulletinNo}/>
                    <GridItem title={'公告日'} content={formatTime("D", patent?.bulletinDate)}/>
                    <GridItem title={'初审时间'} content={formatTime("D", patent?.initialReviewDate)}/>
                    <GridItem title={'实审时间'} content={formatTime("D", patent?.actualReviewDate)}/>
                    <GridItem title={'届满日'} content={formatTime("D", patent?.boundaryDate)}/>
                    <GridItem title={'费减比例'} content={patent?.retard}/>
                    <GridItem title={'年费监控状态'}
                              content={<Chip size={'small'} color={patent?.isMonitor == 1 ? 'success' : 'error'} label={patent?.isMonitor == 1 ? '监控中' : "未监控"}/>}/>

                </Grid>
                <TabContext value={tab}>
                    <Stack direction="column" spacing={2}>
                        <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                            <TabList scrollButtons={false} variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                                <Tab label="详细信息" value={1}/>
                                <Tab label="合同" value={2}/>
                                <Tab label="对接人" value={8}/>
                                <Tab label="回款" value={7}/>
                                {/*<Tab label="实施节点" value={8}/>*/}
                                <Tab label="相关案件" value={3}/>
                                <Tab label="撰写文稿" value={4}/>
                                <Tab label="案件文件" value={5}/>
                                <Tab label="年费监控" value={6}/>
                            </TabList>
                        </Box>
                        <TabPanel value={1} sx={{mt: 1, p: 0}}>
                            <Stack direction={'column'} gap={2}>
                                <Grid
                                    spacing={3}
                                    container>
                                    <GridItem title={'客户名称'} content={patent?.customerName}/>
                                    <GridItem title={'联系人'} content={patent?.contact}/>
                                    <GridItem title={'联系电话'} content={patent?.mobile}/>
                                    <GridItem title={'业务人员'} content={getSellerNames(patent?.creator, patent?.seller)}/>
                                    <GridItem title={'价格'} content={patent?.price}/>
                                    <GridItem title={'处理人'} content={patent?.handler}/>
                                    <GridItem title={'分配时间'} content={formatTime("D", patent?.assignTime)}/>
                                    <GridItem title={'撰稿人'} content={patent?.writer}/>
                                    <GridItem title={'接收时间'} content={formatTime("D", patent?.receiveTime)}/>
                                    <GridItem title={'内部期限'} content={formatTime("D", patent?.insideDeadline)}/>
                                    <GridItem title={'撰写状态'} content={patent?.writeStatus}/>
                                    <GridItem title={`${writeStatus[patent.writeStatusId] || "撰写"}时间`} content={formatTime("D", patent?.writeStatusTime)}/>
                                    <GridItem size={12} minHeight={80} content={patent?.explain} title={'备注'}/>
                                    <GridItem title={'更新时间'} content={formatTime('D', patent?.updatedAt)}/>
                                    <GridItem title={'创建时间'} content={formatTime('D', patent?.createdAt)}/>
                                </Grid>
                            </Stack>
                        </TabPanel>
                        <TabPanel value={2} sx={{p: 0}}>
                            <ContractDetail data={patent?.contract}/>
                        </TabPanel>
                        <TabPanel value={3} sx={{p: 0}}>
                            <ProTable<PatentPO> loading={patentPagePending} checkboxSelection={false}
                                                showToolbar={false}
                                                onSearch={(params) => checkQueryKey(patent?.contractId) && patentPageMutate({...params, contractId: patent?.contractId})}
                                                data={patentPageData?.data} pageSize={5}
                                                columns={patentColumns} columnHeaderHeight={40}/>
                        </TabPanel>
                        <TabPanel value={4} sx={{p: 0}}>
                            <FileTable tag={19} targetId={drawerId} checkboxSelection={true}
                                       disabled={!(roleName == roleAlias['patenter'] || roleName == roleAlias["processer"] || roleName == roleAlias['superadmin'])}
                                       options={fileCode}/>
                        </TabPanel>
                        <TabPanel value={5} sx={{p: 0}}>
                            <FileTable tag={20} targetId={drawerId} checkboxSelection={true} disabled={!(roleName == roleAlias['processer'] || roleName == roleAlias['superadmin'])}
                                       options={patentStatus}/>
                        </TabPanel>
                        <TabPanel value={6} sx={{p: 0}}>
                            <MonitorTable data={patent?.monitors}/>
                        </TabPanel>
                        <TabPanel value={7} sx={{p: 0}}>
                            <PaybackTable enabled={false} data={patent?.paybacks}/>
                        </TabPanel>
                        <TabPanel value={8} sx={{p: 0}}>
                            <ContactDetail id={patent?.contract?.contactId}/>
                        </TabPanel>
                    </Stack>
                </TabContext>
            </Stack>
        </ResultWrapper>
    </>
};


